import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")

  return (_openBlock(), _createBlock(_component_base_button, {
    tag: "a",
    href: $options.backProjectUrl,
    theme: $props.theme,
    animation: $options.buttonAnimationType,
    "aria-label": $options.title,
    class: "_flexbtwn gfu-1of1 _gap-2",
    onClick: $options.onClick,
    "data-qa": "back-project-button"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_base_icon, {
        name: "brand-flat",
        "icon-namespace": "ga"
      }),
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString($options.title), 1 /* TEXT */)
      ]),
      (!$props.isStacked)
        ? (_openBlock(), _createBlock(_component_base_icon, {
            key: 0,
            name: "brand-flat",
            "icon-namespace": "ga",
            class: "is-invisible"
          }))
        : _createCommentVNode("v-if", true)
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["href", "theme", "animation", "aria-label", "onClick"]))
}